import React, { useMemo, useState } from "react";
import { compose } from "redux";
import { withStyles, withBreakpoint, withMobile } from "components/common";

import Table from "components/common/Table";
import axios from "axios";
import { track } from "../../../utils/analytics";

const moment = require("moment-timezone");

const PreapprovalTable = ({
  users = [],
  loading,
  breakpointContext: { isBelow }
}) => {
  const [invitedIds, setInvitedIds] = useState([]);

  const triggerInvite = (email, e) => {
    console.log(`sending invite to ${email}`);
    track("DASHBOARD_ADMIN_TRIGGERED_INVITE", {
      userInvited: email
    });

    setInvitedIds(invitedIds.push(email));
    e.target.innerHTML = "invited!";
    const jwt = window.localStorage.getItem("jwt");
    axios
      .post(
        "/notifyWaitlistedUser",
        {
          to: email
        },
        {
          headers: { Authorization: `Bearer ${jwt}` }
        }
      )
      .then(response => {
        alert("invite successful");
      })
      .catch(error => {
        console.log(error);
        track("DASHBOARD_ADMIN_ERROR_INVITE_FAILED", {
          userInvited: email
        });
        alert("invite failed");
      });
    return false;
  };

  const buildTrigger = data => (
    <button
      disabled={invitedIds.includes(data.email)}
      onClick={e => {
        if (invitedIds.includes(data.email)) {
          e.preventDefault();
          window.alert("Already invited");
          return false;
        }
        triggerInvite(data.email, e);
      }}
    >
      Invite
    </button>
  );

  const computeColumns = belowMd =>
    belowMd
      ? [
          {
            Header: "Email",
            accessor: "email"
          },
          {
            Header: "Sign up date",
            accessor: 'created_at',
            Cell: ({ value }) =>
              moment(value).tz("America/Los_Angeles")
                ? moment
                    .unix(value / 1000)
                    .tz("America/Los_Angeles")
                    .format("MMM D, YYYY, h:mma")
                : "N/A"
          },
          {
            Header: "Name",
            accessor: data =>
              (data.application && data.application.full_name) || "none"
          },
          {
            Header: "age",
            accessor: data =>
              (data.application && data.application.age) || "none"
          },
          {
            Header: "SSN?",
            accessor: data =>
              data.application && data.application.has_ssn ? "SSN" : "NO SSN"
          },
          {
            Header: "monthly income",
            accessor: data =>
              (data.application && data.application.total_monthly_income) ||
              "none"
          },
          {
            Header: "acct balance",
            accessor: data =>
              (data.application && data.application.total_account_balances) ||
              "none"
          },
          {
            Header: "Approved for",
            accessor: data =>
              data.application &&
              data.application.min_limit &&
              data.application.max_limit
                ? `${data.application.min_limit} - ${data.application.max_limit}`
                : "none"
          },
          {
            Header: "invite",
            accessor: data => buildTrigger(data)
          }
        ]
      : [
          {
            Header: "Email",
            accessor: data => (
              data.email + (data.referrers && data.referrers.length ? '\n'+data.referrers[0].sender_email : '')
            ),
            Cell: ({ value }) => (
              <div className="flex-1 ml-1 md:ml-0">
                <div>
                  {value.split('\n')[0]}
                </div>
                <div className="text-gray-500 text-sm md:text-sm">
                  {!!value.split('\n')[1] && ('referred by: '+value.split('\n')[1])}
                </div>
              </div>
            )
          },
          {
            Header: "Sign up date",
            accessor: 'created_at',
            Cell: ({ value }) =>
              moment(value).tz("America/Los_Angeles")
                ? moment
                    .unix(value / 1000)
                    .tz("America/Los_Angeles")
                    .format("MMM D, YYYY, h:mma")
                : "N/A"
          },
          {
            Header: "Name",
            accessor: data =>
              (data.application && data.application.full_name) || "none"
          },
          {
            Header: "age",
            accessor: data =>
              (data.application && data.application.age) || "none"
          },
          {
            Header: "SSN?",
            accessor: data =>
              data.application && data.application.has_ssn ? "SSN" : "NO SSN"
          },
          {
            Header: "Phone?",
            accessor: data =>
              data.phone_number && data.phone_number.length > 0 ? "phone" : ""
          },
          {
            Header: "monthly income",
            accessor: data =>
              (data.application && data.application.total_monthly_income) ||
              "none"
          },
          {
            Header: "acct balance",
            accessor: data =>
              (data.application && data.application.total_account_balances) ||
              "none"
          },
          {
            Header: "Approved for",
            accessor: data =>
              data.application &&
              data.application.min_limit &&
              data.application.max_limit
                ? `${data.application.min_limit} - ${data.application.max_limit}`
                : "none"
          },
          {
            Header: "invite",
            accessor: data => buildTrigger(data)
          }
        ];

  const columns = useMemo(() => computeColumns(isBelow("md")), [
    computeColumns,
    isBelow
  ]);

  const getRowStyle = row => {
    return {
      backgroundColor: row.original.application.is_preapproved
        ? "#E5FFE5"
        : "#FFE4E5"
    };
  };

  return (
    <div className="mt-5">
      <h1 className="text-2xl font-title mb-2 font-light">
        Admin: Preapprovals
      </h1>
      <div className="my-6">
        {loading ? (
          <div>Loading...</div>
        ) : users.length ? (
          <Table
            id="referrals-table"
            data={users}
            columns={columns}
            getRowStyle={getRowStyle}
            itemsPerPage={20}
            defaultSortOrder={{ idx: 1, order: true }}
          />
        ) : (
          <div>Your Preapproval List is currently empty!</div>
        )}
      </div>
    </div>
  );
};

export default compose(
  withMobile,
  withStyles,
  withBreakpoint
)(PreapprovalTable);
